import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

function RoleProtectedRoute({ children, allowedRoles = [], requiredTab, redirectTo = '/login' }) {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-gray-900"></div>
      </div>
    );
  }

  if (!user) {
    return <Navigate to={redirectTo} replace />;
  }

  if (!allowedRoles.includes(user.role)) {
    return <Navigate to="/dashboard" replace />;
  }

  if (requiredTab) {
    const tabs = Array.isArray(user.allowed_tabs) ? user.allowed_tabs : [];
    if (!tabs.includes(requiredTab)) {
      return <Navigate to="/dashboard" replace />;
    }
  }

  return children;
}

export default RoleProtectedRoute;
